import type { ChatMessageItem } from '@/apis/chatbot'
import type { ParametersWithInput, ParametersWithProperty } from '@/apis/agent'
import { request } from './lib'

interface AgentListParameters {
  function_id: string | undefined
  workspace_id?: string
}
interface PushMessage {
  conversation_id: string | undefined
  content: string
  tips: any[]
  to_context: boolean
}

interface ConsumeInfo {
  consume_mode: string
  consume?: string
  model_list?: Array<{ model: string; consume: string }>
}

export interface Parameters {
  type: string
  description: string
  label: string
  default: any
  example: any
}

export interface Metadata {
  type: 'string' | 'int' | 'bool'
  display_name: string
  component: string
  required: boolean
  description: string
  value: any
  options?: Array<{ label: string; value: any }>
}

export interface PluginInfoResponse {
  function_id: string
  name: string
  // type:
  description: string
  display_name: string
  label: string
  is_new: boolean
  parameters: ParametersWithInput | ParametersWithProperty
  metadata_config: {
    icon: string
    properties: {
      inputs: Record<string, Metadata>
      outputs: unknown
    }
  }
  consume_info: ConsumeInfo
  usage_demo: {
    context: ChatMessageItem[]
  }
  resp_sample: any
}

export function getSkillList({ function_id }: AgentListParameters) {
  return request.get(`/v1/agent/utility/${function_id}/detail`)
}
export function getAddPluginToAgent(body: any) {
  return request.post('/v1/agent/utility/function/create', body)
}
export function getAgentList({
  function_id,
  workspace_id,
}: AgentListParameters) {
  return request.get(`/v1/agent/function/rel?function_id=${function_id}`, {
    headers: {
      workspace_id,
    },
  })
}
export function getPluginPageConfig() {
  return request.get('/v1/agent/plugin/template')
}
export function getPushMsg(body: PushMessage) {
  return request.post('/v1/chat/push_msg', body)
}

export function getPluginInfo(
  function_id: string,
): Promise<PluginInfoResponse> {
  return request.get(`/v1/completion_function/${function_id}/detail`)
}
